import { computed, Injectable, signal } from '@angular/core';

import { Website } from '../model/website';

/**
 * The shop. Every page carries it, so this holds what the last resolved route brought rather
 * than fetching anything of its own - which is what keeps a page render to one API call.
 */
@Injectable({ providedIn: 'root' })
export class WebsiteService {

  /** Written by the route resolver, off the page it just fetched. */
  readonly website = signal<Website | undefined>(undefined);

  /**
   * The shop a template reads. A signal rather than a plain value, so a component holds
   * something that stays live instead of a snapshot taken when it was built.
   *
   * <p>Nothing renders before a route has resolved, so components can rely on the website being
   * there instead of guarding every field.
   */
  readonly current = computed<Website>(() => {
    const website = this.website();
    if (!website) {
      throw new Error('The website is not loaded yet');
    }
    return website;
  });

}
